import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { MerchantProvider } from "./context/merchant";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <MerchantProvider>
      <App />
    </MerchantProvider>
    <ToastContainer />
  </BrowserRouter>
);
